export const queueMacrotask = (task)=>{
    return window.setTimeout(task, 0);
};
